import {
  Box,
  BoxProps,
  ButtonGroup,
  ButtonGroupProps,
  styled,
} from "@mui/material";
import { motion } from "motion/react";

const BaseTabContainer = ({
  variant = "contained",
  size = "small",
  color = "secondary",
  disableElevation = true,
  ...rest
}: ButtonGroupProps) => {
  return (
    <ButtonGroup
      variant={variant}
      size={size}
      color={color}
      disableElevation={disableElevation}
      {...rest}
    />
  );
};

export const TabContainer = styled(BaseTabContainer)<{ noGrow?: boolean }>(
  ({ theme, noGrow }) => ({
    overflow: "hidden",
    borderRadius: theme.shape.borderRadius,
    maxWidth: "100%",
    "& .MuiButtonGroup-grouped:not(:last-of-type)": {
      borderColor: "white",
      borderWidth: 2,
    },
    "& .MuiButtonBase-root.MuiButtonGroup-grouped": noGrow
      ? {
          minWidth: 0,
        }
      : {},
  }),
);

export const TabWrapper = ({ children, ...rest }: BoxProps) => (
  <Box
    component={motion.div}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    {...rest}
  >
    {children}
  </Box>
);
